export default __webpack_public_path__ + "static/media/logo.a25cb05a.png";